export class Accordion {
    accordion: HTMLElement
    contents: NodeListOf<HTMLElement>
    triggers: NodeListOf<HTMLElement>
    openClass: string = 'is-open'

    constructor(accordion: HTMLElement) {
        this.accordion = accordion;
        this.contents = this.accordion.querySelectorAll('[data-accordion-content]');
        this.triggers = this.accordion.querySelectorAll('[data-accordion-trigger]');
        this.addTriggerEvents();
    }

    addTriggerEvents() {
        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                const key = trigger.dataset.accordionTrigger;
                const alreadyOpen = trigger.classList.contains(this.openClass);
                this.closeAll();
                trigger.scrollIntoView(
                    {
                        behavior: 'smooth',
                        block: 'center'
                    }
                );
                if (!alreadyOpen) {
                    trigger.classList.add(this.openClass);
                    this.accordion.querySelector('[data-accordion-content="' + key + '"]')?.classList.add(this.openClass);
                }
            });
        });
    }

    closeAll() {
        this.triggers.forEach((trigger) => {
            trigger.classList.remove(this.openClass);
        });
        this.contents.forEach((content) => {
            content.classList.remove(this.openClass);
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll<HTMLElement>('[data-accordion]').forEach((accordion) => {
        new Accordion(accordion);
    });
});